import styled from 'styled-components';
import tw from 'twin.macro';

export const Section = styled.section`
  ${tw`py-24`}
`;

export const Container = styled.div`
  ${tw`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8`}
`;

export const Grid = styled.div`
  ${tw`grid lg:grid-cols-2 grid-cols-1`}
`;

export const LeftSection = styled.div`
  ${tw`lg:mb-0 mb-10`}
`;

export const ImageContainer = styled.div`
  ${tw`relative h-full`}
`;

export const Image = styled.img`
  ${tw`w-full h-full lg:rounded-l-2xl rounded-2xl object-cover`}
`;

export const Overlay = styled.div`
  ${tw`absolute top-0 w-full lg:p-11 p-5`}
`;

export const Card = styled.div`
  ${tw`bg-white rounded-lg p-6`}
`;

export const ContactLink = styled.a`
  ${tw`flex items-center mb-6 no-underline`}
`;

export const Icon = styled.svg`
  ${tw`w-8 h-8`}
`;

export const ContactText = styled.h5`
  ${tw`text-black text-base uppercase font-normal leading-6 ml-5`}
`;

export const RightSection = styled.div`
  ${tw`bg-gray-50 p-5 lg:p-11 lg:rounded-r-2xl rounded-2xl`}
`;

export const Heading = styled.h2`
  ${tw`text-indigo-600 text-4xl font-semibold leading-10 mb-11`}
`;

export const Input = styled.input`
  ${tw`w-full h-12 text-gray-600 placeholder-gray-400 shadow-sm bg-transparent text-lg font-normal leading-7 rounded-full border border-gray-200 focus:outline-none pl-4 mb-10`}
`;

export const TextArea = styled.textarea`
  ${tw`w-full h-36 text-gray-600 placeholder-gray-400 shadow-sm bg-transparent text-lg font-normal leading-7 rounded-2xl border border-gray-200 focus:outline-none pl-4 pt-2 mb-10`}
`;

export const PrivacyContainer = styled.div`
  ${tw`flex items-start mb-10`}
`;

export const Checkbox = styled.input`
  ${tw`w-5 h-5 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500`}
`;

export const PrivacyText = styled.label`
  ${tw`ml-3 text-gray-600 text-sm font-normal leading-6`}
`;

export const PrivacyLink = styled.a`
  ${tw`text-black underline`}
`;

export const SubmitButton = styled.button`
  ${tw`w-full h-12 bg-indigo-600 text-white  text-lg font-semibold leading-7 rounded-full shadow-md hover:bg-indigo-700 focus:outline-none`}
`;
